import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const provinces = async (data: LocationReqT) => {
  const { id, name, pageParam } = data;
  const qs = `?page=${pageParam ?? 1}&q=${name ?? ""}`;
  return axios.get(Routes.PROVINCES + `/${id}` + qs);
};

export const useProvinces = (params: LocationReqT) => {
  const { id, name } = params;
  return useInfiniteQuery({
    queryKey: [Keys.PROVINCES_QRY, id, name],
    queryFn: ({ pageParam = 1 }) => provinces({ pageParam, id, name }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    enabled: id ? true : false,
    cacheTime: 0,
    staleTime: 0,
  });
};
